/* -----------------------------------------
  Header
------------------------------------------- */
class CustomHeader extends HTMLElement {
  constructor() {
    super()
    this.announceBar = this.querySelector('.p-announce-bar')
    this.announceClose = this.querySelector('[data-announce-close]')

    this.menuBtn = this.querySelector('[data-menu-btn]')
    this.headerNav = this.querySelector('.s-header__nav')

    this.initializeEvents()
  }

  initializeEvents() {
    window.addEventListener('load', () => {
      this.setStatusClass()
    })
    window.addEventListener('scroll', () => {
      this.setStatusClass()
    })

    if (this.announceBar && this.announceClose) {
      this.announceClose.addEventListener('click', () => {
        customSlideUp(this.announceBar)
      })
    }

    if (this.menuBtn && this.headerNav) {
      this.menuBtn.addEventListener('click', () => {
        this.classList.toggle('is-nav-open')
      })
    }
  }

  setStatusClass() {
    if (window.scrollY > window.innerHeight / 5) {
      this.classList.add('is-scrolling')
    } else {
      this.classList.remove('is-scrolling')
    }
  }
}
customElements.define('custom-header', CustomHeader)

/* -----------------------------------------
  Modal
------------------------------------------- */
class CustomModal extends HTMLElement {
  constructor() {
    super()
    this.trigger = this.querySelector('[data-modal-trigger]')
    this.modalEl = this.querySelector('dialog')
    this.closeBtn = this.querySelector('[data-modal-close]')

    this.initialize()
  }

  initialize() {
    if (!this.modalEl) return

    if (this.trigger) {
      this.trigger.addEventListener('click', () => {
        this.modalEl.showModal()
      })
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => {
        this.modalEl.close()
      })
    }

    this.modalEl.addEventListener('click', (e) => {
      if (
        e.target.tagName &&
        e.target.tagName !== '' &&
        e.target.tagName.toUpperCase() === 'DIALOG' &&
        e.target.dataset.needsValidate !== 'true'
      ) {
        this.modalEl.close()
      }
    })
  }
}
customElements.define('custom-modal', CustomModal)

/* -----------------------------------------
  Utils
------------------------------------------- */ /**
 * ページ内スクロール
 * @param {string} id ターゲットのID
 * @param {string} headerSelector ヘッダー要素のセレクタ
 * @param {number} adjust 調整幅
 */
function customAnchorLink(id, headerSelector, adjust) {
  const target = document.getElementById(id)

  const headerSel = headerSelector || '.s-header'
  const header = document.querySelector(headerSel).clientHeight

  if (!target || !window) {
    return
  }

  const targetPos = target.getBoundingClientRect().top + window.scrollY + (adjust || 0) - header

  window.scrollTo({
    top: targetPos,
    behavior: 'smooth',
  })
}

/**
 * slideUpアニメーション
 * @param {Element} target 動作させる要素
 * @param {number} duration 秒数
 */
function customSlideUp(target, duration = 300) {
  target.style.transitionProperty = 'height, margin, padding'
  target.style.transitionDuration = duration + 'ms'
  target.style.boxSizing = 'border-box'
  target.style.height = target.offsetHeight + 'px'
  target.offsetHeight
  target.style.overflow = 'hidden'
  target.style.height = '0'
  target.style.paddingTop = '0'
  target.style.paddingBottom = '0'
  target.style.marginTop = '0'
  target.style.marginBottom = '0'
  window.setTimeout(() => {
    target.style.display = 'none'
    target.style.removeProperty('height')
    target.style.removeProperty('padding-top')
    target.style.removeProperty('padding-bottom')
    target.style.removeProperty('margin-top')
    target.style.removeProperty('margin-bottom')
    target.style.removeProperty('overflow')
    target.style.removeProperty('transition-duration')
    target.style.removeProperty('transition-property')
  }, duration)
}

/**
 * slideDownアニメーション
 * @param {Element} target 動作させる要素
 * @param {number} duration 秒数
 */
function customSlideDown(target, duration = 300) {
  target.style.removeProperty('display')
  let display = window.getComputedStyle(target).display

  if (display === 'none') display = 'block'

  target.style.display = display

  let height = target.offsetHeight

  target.style.overflow = 'hidden'
  target.style.height = '0'
  target.style.paddingTop = '0'
  target.style.paddingBottom = '0'
  target.style.marginTop = '0'
  target.style.marginBottom = '0'
  target.offsetHeight
  target.style.boxSizing = 'border-box'
  target.style.transitionProperty = 'height, margin, padding'
  target.style.transitionDuration = duration + 'ms'
  target.style.height = height + 'px'
  target.style.removeProperty('padding-top')
  target.style.removeProperty('padding-bottom')
  target.style.removeProperty('margin-top')
  target.style.removeProperty('margin-bottom')

  window.setTimeout(() => {
    target.style.removeProperty('height')
    target.style.removeProperty('overflow')
    target.style.removeProperty('transition-duration')
    target.style.removeProperty('transition-property')
  }, duration)
}

/**
 * slideToggleアニメーション
 * @param {Element} target 動作させる要素
 * @param {number} duration 秒数
 */
function customSlideToggle(target, duration = 300) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration)
  } else {
    return slideUp(target, duration)
  }
}

/* -----------------------------------------
  Section scroll from URL query
------------------------------------------- */
/**
 * URLの?section=id が存在する場合、該当セクションへスクロール
 */
function initSectionScrollFromUrl() {
  const params = new URLSearchParams(window.location.search)
  const sectionId = params.get('section')

  if (sectionId) {
    window.addEventListener('load', () => {
      customAnchorLink(sectionId)
    })
  }
}
initSectionScrollFromUrl()
